import { render, staticRenderFns } from "./Dashjs.vue?vue&type=template&id=78cb0326&scoped=true&"
import script from "./Dashjs.vue?vue&type=script&lang=js&"
export * from "./Dashjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cb0326",
  null
  
)

export default component.exports